import type { ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { UserTrash } from '@components'

function Trash(): ReactElement {
  return <UserTrash />
}

export const Route = createFileRoute('/settings/company_/user_/trash/')({
  component: Trash,
})
